// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"c6f824b2","858":"13395a5e"}[chunkId] + ".chunk.js";
};